import { useCachedApiCall } from '@hooks/apiCall';
import {
    costPlanCache,
    employeesCriticalWorkMinutesCache,
    resultBreachesCache,
    shiftGeneratorResultCache,
} from './shiftGeneratorResultStore';

/*
 * Thin cache-backed bindings so hooks and features don't hand-roll
 * param arrays. See docs/api-caching.md §8 for the hook contract.
 */

/** Cache-backed shift generator result of a task. */
export const useShiftGeneratorResultEntry = (
    departmentId?: string,
    taskId?: string,
) => useCachedApiCall(shiftGeneratorResultCache, [departmentId, taskId]);

/** Cache-backed cost plan of a task. */
export const useCostPlanEntry = (departmentId?: string, taskId?: string) =>
    useCachedApiCall(costPlanCache, [departmentId, taskId]);

/** Cache-backed critical work minutes of a task. */
export const useEmployeesCriticalWorkMinutesEntry = (
    departmentId?: string,
    taskId?: string,
) =>
    useCachedApiCall(employeesCriticalWorkMinutesCache, [departmentId, taskId]);

/** Cache-backed staffing breaches of a task. */
export const useResultBreachesEntry = (
    departmentId?: string,
    taskId?: string,
    rules?: string[],
) => useCachedApiCall(resultBreachesCache, [departmentId, taskId, rules]);
